

export default {
  props: ["ready"],
  name: "item",
  data() {
    return {
      index: null,
      item: JSON.parse(JSON.stringify(this.$store.getters.item)),
      commentExpand: false,
      commentOverflow: false,
      inCart: false,
      friendly_name: {
        cover: "Εξώφυλλο",
        pages: "Σελίδες",
        weight: "Βάρος",
        release_date: "Ημερομηνία κυκλοφορίας",
        dimensions: "Διαστάσεις",
        isbn: "ISBN",
        persons: "Συντελεστές",
        series: "Σειρά",
      },
      options: [],
      selectedOption: "",
      inited: false,
      relatives: [],
      tab: "info",
    };
  },
  watch: {
    quantity: function (v) {
      if (v < 1) {
        this.quantity = 1;
      }
    },
  },
  async mounted() {
    if (
      document.querySelector(".comment") &&
      document.querySelector(".comment").scrollHeight > 100
    ) {
      this.commentOverflow = true;
    }
    if (
      this.item.availability &&
      this.item.availability.status == "Υπό έκδοση"
    ) {
      this.$store.commit("labels", { cart: "Προπαράγγειλέ το!" });
    }
    if (this.params && !this.inited) {
      this.inited = true;
      if (!this.item) {
        return;
      }
    }
    let flat_tags = {};
    this.item.tags.forEach((t) => {
      flat_tags[t.key] = t.value;
    });
    this.item.flat_tags = flat_tags;
    let tempItems = this.$hyperCart.getCart().items.filter((i) => {
      if (
        JSON.stringify(i.variation) == JSON.stringify(this.item.variation) &&
        this.item._id == i._id
      ) {
        return i;
      }
    }).length;
    this.inCart = tempItems;
    this.$nuxt.$on("updateCart", () => {
      let tempItems = this.$hyperCart.getCart().items.filter((i) => {
        if (
          JSON.stringify(i.variation) == JSON.stringify(this.item.variation) &&
          this.item._id == i._id
        ) {
          return i;
        }
      }).length;
      this.inCart = tempItems;
    });
  },
  methods: {
    setVariation(io, value, index) {
      if (!value) {
        delete io.selected;
      } else {
        io.selected = value;
      }
      let variations = this.item.variation;
      if (variations) {
        let found = -1;
        variations.forEach((v, vindex) => {
          if (v && v.key == io.key) {
            found = vindex;
          }
        });
        if (found == -1 && value) {
          variations.push({ ...(value || {}) });
        } else {
          if (!value) {
            delete variations[found];
          } else {
            variations[found] = value;
          }
        }
      } else if (value) {
        variations = [{ ...(value || {}) }];
      }
      let tempItems = this.$hyperCart.getCart().items.filter((i) => {
        if (
          JSON.stringify(i.variation) == JSON.stringify(variations) &&
          this.item._id == i._id
        ) {
          return i;
        }
      }).length;
      if (variations && variations[0] == null) {
        delete this.item.variation;
      } else {
        this.item.variation = variations;
      }
      this.item.prices.actual_price = this.$hyperItem.actualPrice(this.item).toFixed(2);
      this.inCart = tempItems;
      this.$forceUpdate();
    },
    addCart() {
      if (this.item.moq && this.item.quantity < this.item.moq) {
        this.$clerk.hyperAlert({
          time: 0,
          title: "Τεμάχια",
          text: "Η ποσότητα ελάχιστης παραγγελίας είναι μεγαλύτερη από τα τεμάχια που επιλέξατε!",
          cancelShow: false,
          icon: "warning",
        });
        return;
      }
      this.$hyperCart.addToCart(this.item, this.$hyperCart.getCart());
      this.inCart = true;
      $nuxt.$emit("updateCart", "updated");
    },
  },
};
